import { Dialog } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGamification } from "../../context/GamificationContext";
import { addUserActivity } from "../../redux/actions/profileDetails";
import {
  getCertificateLink,
  getCertificateStatus,
} from "../../redux/actions/certificate";
import { useNavigate } from "react-router-dom";
import Spinner from "../Spinner";
import { IKImage } from "imagekitio-react";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

export default function Gamification({
  children,
  callback,
  modalType,
  activityDetails,
  callbackData,
  mskill_slug,
  heroImage,
}) {
  const { openConfirmationModal, setOpenConfirmationModal, type } =
    useGamification();
  const available_coins = useSelector(
    (store) => store?.profileDetails?.user_coins_data?.[0]?.["available-coins"],
  );
  const college_coins = useSelector(
    (store) => store?.profileDetails?.user_college?.coin_quota?.current_coins,
  );
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const [certificateStatus, setCertificateStatus] = useState(null);
  const [triggerCoinSpend, setTriggerCoinSpend] = useState(false);
  const [heroTempImage, setHeroTempImage] = useState(null);
  const email = useSelector((store) => store?.profileDetails?.email);

  const [coinType, setCoinType] = useState("personal");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function spendCoinsHandler(activityDetails) {
    dispatch(
      addUserActivity(
        user_id,
        activityDetails,
        "",
        coinType === "college" ? true : false,
      ),
    );
    if (callbackData) {
      callback(callbackData);
    } else {
      callback();
    }
    setTriggerCoinSpend(false);
    setOpenConfirmationModal(false);
  }

  useEffect(() => {
    if (type === modalType) {
      if (
        activityDetails.type.includes("download") &&
        !activityDetails.type.includes("certificate_skill")
      ) {
        dispatch(
          getCertificateStatus(user_id, mskill_slug, (successObj) => {
            setCertificateStatus(successObj);
          }),
        );
      }
    }
  }, [openConfirmationModal]);

  useEffect(() => {
    if (triggerCoinSpend && openConfirmationModal) {
      if (type === modalType) {
        spendCoinsHandler(activityDetails);
      }
    }
  }, [triggerCoinSpend]);

  useEffect(() => {
    let timer;
    if (activityDetails.type.includes("certificate")) {
      if (
        !college_coins &&
        available_coins >= activityDetails?.cost &&
        openConfirmationModal
      ) {
        timer = setTimeout(() => {
          setTriggerCoinSpend(true);
        }, 3000);
      }
    } else {
      if (available_coins >= activityDetails?.cost && openConfirmationModal) {
        if (type === modalType) {
          timer = setTimeout(() => {
            setTriggerCoinSpend(true);
          }, 3000);
        }
      }
    }

    return () => {
      clearTimeout(timer);
    };
  }, [openConfirmationModal]);

  useEffect(() => {
    if (
      type === modalType &&
      openConfirmationModal === true &&
      callbackData &&
      !heroImage
    ) {
      dispatch(
        getCertificateLink(
          callbackData?.unique_certificate_id,
          "image_png",
          (link) => {
            setHeroTempImage(link);
          },
        ),
      );
    }
  }, [openConfirmationModal, modalType]);

  const handlePremiumClick = (e) => {
    Mixpanel.track(Constants.Mixpanel.START_PREMIUM_CLICK, {
      distinct_id: email,
    });
    navigate("/pricing?type=annual");
  };

  const handleBuyCoinsClick = (e) => {
    Mixpanel.track(Constants.Mixpanel.START_PREMIUM_CLICK, {
      distinct_id: email,
    });
    navigate("/pricing?type=coin");
  };

  return (
    <>
      {children}
      <Dialog
        open={openConfirmationModal && type === modalType}
        onClose={() => setOpenConfirmationModal(false)}
        as="div"
        className="fixed inset-0 z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto md:mt-28 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-20 mx-2 flex w-11/12 flex-col items-center justify-between rounded bg-white p-4 md:w-1/3">
          {/* FLOW FOR LABELS */}
          {activityDetails.type.includes("certificate") ? (
            !college_coins ? (
              available_coins < activityDetails?.cost ||
              college_coins < activityDetails?.cost ? (
                <div className="mb-4 flex flex-col items-center justify-between">
                  <h2 className="text-xl font-bold">
                    {activityDetails?.type === "download_paid_certificate_skill"
                      ? "You Need 500 Coins To Unlock"
                      : "You don't have enough Coins"}
                  </h2>
                  <p className="my-3 text-center text-sm">
                    {activityDetails?.type === "download_paid_certificate_skill"
                      ? "Skill Certificates are the ultimate & increase interview chances by 61% when present in your CV/LinkedIn."
                      : "You don’t have enough coins to unlock this certificate. Buy more coins or upgrade to pro."}
                  </p>
                </div>
              ) : (
                <p className="text-lg font-bold">please wait</p>
              )
            ) : (
              <div className="mb-4 flex flex-col items-center justify-between">
                <h2 className="text-xl font-bold">
                  Unlock Certificate using Coins
                </h2>
                <p className="my-3 text-center text-sm">
                  Do you want to use your personal coins or your college coins?
                </p>
              </div>
            )
          ) : available_coins < activityDetails?.cost ? (
            <div className="mb-4 flex flex-col items-center justify-between">
              <h2 className="text-xl font-bold">
                {activityDetails?.type === "download_paid_certificate_skill"
                  ? "You Need 500 Coins To Unlock"
                  : "You don't have enough Coins"}
              </h2>
              <p className="my-3 text-center text-sm">
                {activityDetails?.type === "download_paid_certificate_skill"
                  ? "Skill Certificates are the ultimate & increase interview chances by 61% when present in your CV/LinkedIn."
                  : "You don’t have enough coins to unlock this certificate. Buy more coins or upgrade to pro."}
              </p>
            </div>
          ) : (
            <p className="text-lg font-bold">please wait</p>
          )}

          {activityDetails.type.includes("certificate") ? (
            !college_coins ? (
              available_coins < activityDetails?.cost ||
              college_coins < activityDetails?.cost ? (
                <img
                  src={heroImage ? heroImage : heroTempImage}
                  alt="certificate"
                />
              ) : (
                <Spinner />
              )
            ) : (
              <img
                src={heroImage ? heroImage : heroTempImage}
                alt="certificate"
                className=""
              />
            )
          ) : available_coins < activityDetails?.cost ? (
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src={`https://img.learntube.ai/public-assets/Content_player/notEnoughCoins.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657884212844`}
              className="h-2/3 w-2/3"
              transformation={[
                {
                  height: "260",
                  width: "260",
                },
              ]}
            />
          ) : (
            <Spinner />
          )}

          {/* FLOW FOR CTAS */}

          {activityDetails.type.includes("certificate") ? (
            !college_coins ? (
              available_coins < activityDetails?.cost ||
              college_coins < activityDetails?.cost ? (
                <div className="mt-4 flex w-full items-center justify-evenly">
                  <div className="justify-centet flex flex-col items-center">
                    <button
                      className="rounded-md border-2 border-[#FDBF48] px-3 py-2 text-sm font-bold text-[#FDBF48]"
                      onClick={(e) => handleBuyCoinsClick(e)}
                    >
                      Buy Coins
                    </button>
                    <p className="my-1 text-xs">
                      100{" "}
                      <FontAwesomeIcon
                        icon={faCoins}
                        className="text-amber-500"
                      />{" "}
                      @99{" "}
                    </p>
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    <button
                      className="rounded-md border-2 border-[#FDBF48] bg-[#FDBF48] px-3 py-2 text-sm font-bold"
                      onClick={(e) => handlePremiumClick(e)}
                    >
                      Upgrade to Pro
                    </button>
                    <p className="my-1 flex text-xs">
                      unlimited
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src={`https://img.learntube.ai/public-assets/Content_player/certificate.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657958650750`}
                        className="ml-4 h-6 w-6"
                        transformation={[
                          {
                            height: "60",
                            width: "60",
                          },
                        ]}
                      />
                    </p>
                  </div>
                </div>
              ) : null
            ) : (
              <div className="mt-4 flex w-full items-center justify-evenly">
                <div className="flex flex-col items-center justify-center">
                  <button
                    className="rounded-md border-2 border-[#FDBF48] px-3 py-2 text-sm font-bold text-[#FDBF48]"
                    onClick={() => {
                      setCoinType("college");
                      setTriggerCoinSpend(true);
                    }}
                  >
                    College Coins
                  </button>
                  <p className="my-1 text-xs">
                    Balance: {college_coins}{" "}
                    <FontAwesomeIcon icon={faCoins} className="text-gray-400" />
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <button
                    className="rounded-md border-2 border-[#FDBF48] bg-[#FDBF48] px-3 py-2 text-sm font-bold"
                    disabled={available_coins < activityDetails?.cost}
                    onClick={() => {
                      setCoinType("personal");
                      setTriggerCoinSpend(true);
                    }}
                  >
                    Personal Coins
                  </button>
                  <p className="my-1 text-xs">
                    Balance: {available_coins}{" "}
                    <FontAwesomeIcon
                      icon={faCoins}
                      className="text-amber-500"
                    />
                  </p>
                </div>
              </div>
            )
          ) : available_coins < activityDetails?.cost ? (
            <div className="mt-4 flex w-full items-center justify-evenly">
              {modalType === "ask_task_review" ? (
                <div className="justify-centet flex flex-col items-center">
                  <button
                    className="rounded-md border-2 border-[#FDBF48] bg-[#FDBF48] px-3 py-2 text-sm font-bold"
                    onClick={(e) => handleBuyCoinsClick(e)}
                  >
                    Buy Coins
                  </button>
                  <p className="my-1 text-xs">
                    100{" "}
                    <FontAwesomeIcon
                      icon={faCoins}
                      className="text-amber-500"
                    />{" "}
                    @99{" "}
                  </p>
                </div>
              ) : (
                <>
                  <div className="justify-centet flex flex-col items-center">
                    <button
                      className="rounded-md border-2 border-[#FDBF48] px-3 py-2 text-sm font-bold text-[#FDBF48]"
                      onClick={(e) => handleBuyCoinsClick(e)}
                    >
                      Buy Coins
                    </button>
                    <p className="my-1 text-xs">
                      100{" "}
                      <FontAwesomeIcon
                        icon={faCoins}
                        className="text-amber-500"
                      />{" "}
                      @99{" "}
                    </p>
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    <button
                      className="rounded-md border-2 border-[#FDBF48] bg-[#FDBF48] px-3 py-2 text-sm font-bold"
                      onClick={(e) => handlePremiumClick(e)}
                    >
                      Upgrade to Pro
                    </button>
                    <p className="my-1 flex text-xs">
                      unlimited{" "}
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src={`https://img.learntube.ai/public-assets/Content_player/certificate.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657958650750`}
                        className="ml-4 h-6 w-6"
                        transformation={[
                          {
                            height: "60",
                            width: "60",
                          },
                        ]}
                      />
                    </p>
                  </div>
                </>
              )}
            </div>
          ) : null}
        </div>
      </Dialog>
    </>
  );
}
